import React, { useEffect, useMemo } from "react";
import { Route } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { routes } from "navigation/config";
import queryString from "query-string";
import { LOCALES } from "translation";
import { useLocale } from "hooks";

const Page = ({ route, ...rest }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { lang } = queryString.parse(location.search);
  const { localeState, localeActions } = useLocale();

  const currentRouteConfig = useMemo(() => {
    let currentRouteConfig;
    for (let route in routes) {
      if (routes[route].path === location.pathname) {
        currentRouteConfig = routes[route];
      }
    }
    return currentRouteConfig;
  }, [location]);

  useEffect(() => {
    if (LOCALES.some((el) => el === lang)) {
      if (localeState.locale !== lang) {
        localeActions.changeLocale(lang);
      }
    }
  }, [lang, localeActions, localeState.locale]);

  useEffect(() => {
    if (currentRouteConfig.name !== "home") {
      document.title = `My Daily B... | ${t(currentRouteConfig.title)}`;
    } else {
      document.title = `My Daily Budget App`;
    }

    if (currentRouteConfig.noIndex) {
      document
        .querySelector('meta[name="robots"]')
        .setAttribute("content", "noindex, nofollow");
    } else {
      document
        .querySelector('meta[name="robots"]')
        .setAttribute("content", "all");
    }
  }, [currentRouteConfig, t]);

  return <Route {...rest} />;
};

export default Page;
